class EmbroideryConfig extends HTMLElement {
  #abortController = null;

  connectedCallback() {
    this.toggle = this.querySelector('[ref="toggle"]');
    this.panel = this.querySelector('[ref="panel"]');
    this.colorFieldset = this.querySelector('[ref="colorFieldset"]');
    this.nameInput = this.querySelector('[ref="nameInput"]');
    this.counter = this.querySelector('[ref="counter"]');
    this.threadRef = this.querySelector('[ref="threadRef"]');

    if (!this.toggle || !this.nameInput) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.toggle.addEventListener('change', this.handleToggle, { signal });
    this.nameInput.addEventListener('input', this.handleNameInput, { signal });
    this.addEventListener('change', this.handleColorChange, { signal });

    this.syncState();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  handleToggle = () => {
    this.syncState();
  };

  /**
   * Aplica o estado a partir do checkbox, que é a fonte de verdade.
   * Campos desativados não são submetidos nem validados pelo browser —
   * é isto que torna a personalização opcional sem lógica extra.
   * No modo "roupa+manta" não existe fieldset de cor nem hidden da
   * referência, por isso ambos são opcionais aqui.
   */
  syncState = () => {
    const enabled = this.toggle.checked;

    this.panel.hidden = !enabled;
    this.nameInput.disabled = !enabled;

    if (this.colorFieldset) this.colorFieldset.disabled = !enabled;
    if (this.threadRef) this.threadRef.disabled = !enabled;

    this.counter.textContent = this.nameInput.value.length;
  };

  handleNameInput = () => {
    this.counter.textContent = this.nameInput.value.length;
  };

  handleColorChange = (event) => {
    if (!this.threadRef) return;

    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

    this.threadRef.value = target.dataset.ref || '';
  };
}

if (!customElements.get('embroidery-config')) {
  customElements.define('embroidery-config', EmbroideryConfig);
}